module.exports = __webpack_public_path__ + "static/media/img-2.30770379.jpg";